<mat-card class="management-card">
  <mat-toolbar color="default" class="table-header-toolbar">
    <span>Bus Stops</span>
    <span class="spacer"></span>
    
    <div class="header-actions">
      <button mat-icon-button 
              matTooltip="Show/Hide search" 
              matTooltipClass="tooltip-style" 
              (click)="toggleFiltersVisibility()">
        <mat-icon color="primary">filter_list</mat-icon>
      </button>
      
      <button mat-icon-button 
              (click)="addBusStop()" 
              matTooltip="New bus stop" 
              matTooltipClass="tooltip-style">
        <mat-icon color="primary">add</mat-icon>
      </button>
      
      <button mat-icon-button 
              matTooltip="Export list" 
              matTooltipClass="tooltip-style" 
              (click)="exportar()">
        <mat-icon color="primary">vertical_align_bottom</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <mat-card-content class="table-card-content">
    
    <mcrit-gestio-busstops-filters
      *ngIf="showFilters"
      [validFilters]="busStopsFilters"
      (changeFilter)="computeActiveFilters($event)"
      class="filters-container">
    </mcrit-gestio-busstops-filters>

    <div class="table-container">
      <table class="material-clean-table">
        <thead>
          <tr>
            <th class="actions-column-header">Actions</th>
            <th *ngFor="let field of tableFields" 
                (click)="cycleOrdering(field[0])" 
                class="sortable-column-header">
              <div class="header-cell-content">
                {{ field[1] }}
                <mat-icon class="sort-icon" *ngIf="orderingParameters[field[0]]">
                  {{ orderingParameters[field[0]] === 1 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
            </th>
          </tr>
        </thead>
        
        <tbody *ngIf="busStopData?.rows">
          <tr *ngFor="let busstop of busStopData.rows" class="table-data-row">
            <td class="actions-cell">
             <!-- <button mat-icon-button [matMenuTriggerFor]="actionMenu" 
              [matMenuTriggerData]="{ Id: busstop['id'], busstopId: busstop['id'] }"
              matTooltip="Opcions"
              matTooltipClass="tooltip-style">
                <mat-icon color="primary">more_vert</mat-icon>
              </button>-->
            </td>
            <td *ngFor="let field of tableFields" (click)="editBusStop(busstop)" class="data-cell">
              {{ busstop[field[0]] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-card-content>

   <mat-toolbar class="footer">

    <span class="fill-remaining-space"></span>

    <span style="padding-right: 1em">

      Rows per page: {{listBusStopService.rowsPerPage}}

      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">

        <mat-icon>arrow_drop_down</mat-icon>

      </button>

    </span>

    <span style="padding-right: 1em" *ngIf="busStopData">

      {{firstRegisterShown}} - {{lastRegisterShown}} de {{busStopData.registers}} bus stops

    </span>

    <button mat-icon-button (click)="gotoPage(0)">

      <mat-icon>first_page</mat-icon>

    </button>

    <button mat-icon-button (click)="requestPrevious()">

      <mat-icon>keyboard_arrow_left</mat-icon>

    </button>

    <button mat-icon-button (click)="requestNext()">

      <mat-icon>keyboard_arrow_right</mat-icon>

    </button>

  </mat-toolbar>

</mat-card>

<mat-menu #menuNumberRows y-position="above">
    <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
</mat-menu>

<mat-menu #actionMenu="matMenu" xPosition="after">
  <ng-template matMenuContent let-id="Id" let-busstopId="busstopId">
  </ng-template>
</mat-menu>